module.exports = __webpack_public_path__ + "static/img/number-copy.9ea7db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article_5/portrait/number-copy.png
// module id = eoR1
// module chunks = 1